import {createPortal} from 'react-dom';
import MapPlaceLayers from './MapPlaceLayers';
import React,{useEffect,useRef,useState} from 'react';
import L from 'leaflet';
import PropertyMapPreview from './PropertyMapPreview';
import {mapCoordinates} from '../utils/propertyCoordinates';
import {addIllustratedBasemap} from '../services/illustratedBasemap';
import {propertyMapIcon} from '../utils/mapMarkerIcons';
import './PropertyMapPreview.css';
export default function PropertyLocationMap({property}) {
  const [view,setView]=useState(null),canvas=useRef(null);
  const [placesMap,setPlacesMap]=useState(null);
  const point=mapCoordinates(property),lat=point?.lat,lon=point?.lon;
  useEffect(()=>{setView(null);},[property?.listing_key,property?.id]);
  useEffect(()=>{
    if(!view||lat==null||lon==null||!canvas.current)return undefined;
    const map=L.map(canvas.current,{minZoom:1,maxZoom:19,scrollWheelZoom:true}).setView([view.center.lat,view.center.lng],view.zoom);
    addIllustratedBasemap(map);
    setPlacesMap(map);
    L.marker([lat,lon],{icon:propertyMapIcon(property.current_price??property.price,{isPrivate:property.isPrivate}),title:'Selected property'}).addTo(map);
    const resize=()=>map.invalidateSize({pan:false});
    const observer=typeof ResizeObserver==='undefined'?null:new ResizeObserver(resize);observer?.observe(canvas.current);
    const timer=setTimeout(resize,50);
    const escape=event=>{if(event.key==='Escape'){event.stopPropagation();setView(null);}};
    document.addEventListener('keydown',escape,true);
    return()=>{clearTimeout(timer);observer?.disconnect();document.removeEventListener('keydown',escape,true);setPlacesMap(null);map.remove();};
  },[view,lat,lon,property.current_price,property.price,property.isPrivate]);
  if(!point)return null;
  return <><PropertyMapPreview property={property} onExpand={setView} />
    {view&&createPortal(<div className="property-location-map-overlay" onClick={event=>{event.stopPropagation();if(event.target===event.currentTarget)setView(null);}}>
      <div className="property-location-map-dialog" role="dialog" aria-modal="true" aria-label="Interactive property map" onClick={event=>event.stopPropagation()}>
        <button type="button" className="property-location-map-close" onClick={()=>setView(null)} aria-label="Close map">×</button>
        <div ref={canvas} className="property-location-map-canvas" />
        <MapPlaceLayers map={placesMap} listingKey={property.listing_key} />
      </div>
    </div>,document.body)}
  </>;
}
